export const ERROR_FORBIDDEN_COPY = {
  body: 'Contact your organization administrator and request the right role for you.',
  title: 'Continue to admin dashboard',
};
